import financeReportsController from './finance'
import inventoryMovementSummaryController from './inventoryMovementSummary'
import inventoryStockCardController from './inventoryStockCard'
import itemsReportsController from './items'

export default {
  finance: financeReportsController,
  inventoryMovementSummary: inventoryMovementSummaryController,
  inventoryStockCard: inventoryStockCardController,
  items: itemsReportsController,
}
